export default {
  metaTitle: '管理满减活动商品',
  pageTitle: '管理满减活动商品',
  radio1: '处理中',
  radio2: '尚未开始',
  creationTime: '创建时间',
  typeOfEvent: '活动类型',
  eventInPeriod: '活动周期',
  activity1: '促销活动',
  activity2: '活动展示名',
  activity3: '促销类型',
  activity4: '满',
  activity5: '减',
  activity6: '活动起始时间',
  activity7: '抵扣选项',
  activity8: '适用店铺',
  activity9: '创建的时间',
  activity10: '商品报名',
  typeList1: '所有',
  typeList2: '满减',
  activitylist: '满减',
  statusDisplaylist1: '待审核',
  statusDisplaylist2: '尚未开始',
  statusDisplaylist3: '处理中',
  statusDisplaylist4: '已过期',
  statusDisplaylist5: '取消或拒绝',
  columns1: 'ID',
  columns2: '活动名',
  columns3: '创建时间',
  columns4: '审核时间',
  columns5: '活动类型',
  columns6: '活动内容',
  columns7: '状态',
  columns8: '已报名商品',
  columns9: '详情',
  btn1: '详情',
  btn2: '商品',
  btn3: '可报名品类',
  type1: '满减',
  disable1: '禁用店铺券',
  disable2: '禁用平台券',
  disable3: '禁用积分',
  allStore: '所有店铺'
}
